// extracted by mini-css-extract-plugin
export default {"headerLayout":"ModalConfirmation_headerLayout__G5eVa","bodyLayout":"ModalConfirmation_bodyLayout__Jvbe-"};